module.exports = __webpack_public_path__ + "static/media/turbonomic.3b3702e2.png";